import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { Fragment, PureComponent } from 'react';

import { insertContentState } from 'my-core/editor-utils';

import ToolbarButton from './ToolbarButton';

// import DropDownButton from './DropDownButton';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';

import { faCode } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class RawDataInputManager extends PureComponent {
  state = { value: '', show: false };

  updateEditorContent = e => this.setState({ value: e.target.value, errorMessage: null });

  insertContent = () => {
    const { editorState, onUpdateEditorState } = this.props;
    const { value } = this.state;
    try {
      const insertRawContent = JSON.parse(value);
      if (!(insertRawContent && Array.isArray(insertRawContent.blocks))) {
        return this.setState({ errorMessage: 'JSON input should be of format: { blocks: Array, entityMap: Object }' });
      }
      const currentRawContent = convertToRaw(editorState.getCurrentContent());
      const blockKey = editorState.getSelection().getStartKey();
      const newRawContent = insertContentState(currentRawContent, insertRawContent, blockKey);
      const newContentState = convertFromRaw(newRawContent);
      onUpdateEditorState(EditorState.push(editorState, newContentState, 'insert-fragment'));
      this.closeEditor();
    } catch (ignoreErr) {
      this.setState({ errorMessage: 'Could not parse JSON input' });
    }
  };

  showEditor = (_, e) => {
    this.setState({ show: true, target: e.currentTarget });
    this.props.onSetActive(true);
  };

  closeEditor = () => {
    this.setState({ show: false });
  };

  editorClosed = () => {
    this.setState({ value: '' });
    this.props.onSetActive(false);
  };

  render() {
    const { errorMessage, show, target, value } = this.state;
    return (
      <Fragment>
        <ToolbarButton onToggle={this.showEditor} tooltip="raw data import (experimental)">
          <FontAwesomeIcon icon={faCode} />
        </ToolbarButton>
        <Popover
          anchorEl={target}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          css={rootCss}
          onClose={this.closeEditor}
          open={show}
          slotProps={{ paper: { className: 'RDI-popover' }, transition: { onExited: this.editorClosed } }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <TextField
            className="RDI-input"
            error={!!errorMessage}
            fullWidth
            helperText={errorMessage}
            maxRows={10}
            minRows={5}
            multiline
            onChange={this.updateEditorContent}
            placeholder="(experimental feature): Enter the raw JSON content that you want inserted"
            slotProps={{ input: { notched: false } }}
            value={value}
          />
          <Button disabled={!value} onClick={this.insertContent} size="small" variant="contained">
            Done
          </Button>
        </Popover>
      </Fragment>
    );
  }
}

const rootCss = ({ spacing, zIndex }) => ({
  zIndex: `${zIndex.modal + 2} !important`,
  '.RDI-popover': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: spacing(1),
  },
  '.RDI-input': {
    display: 'block',
    minWidth: 300,
    marginBottom: spacing(1),
  },
});

/* TEST INPUT:

{
  "blocks": [
    {
      "key": "ba37h",
      "text": "Here is my sample content",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": []
    },
    {
      "key": "23b1m",
      "text": " ",
      "type": "atomic",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [{"offset": 0, "length": 1, "key": 0}]
    },
    {
      "key": "6mdre",
      "text": "Another unstyled line",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": []
    }
  ],
  "entityMap": {
    "0": {
      "type": "EQUATION",
      "mutability": "IMMUTABLE",
      "data": {
        "latex": "\\frac{1}{2}x^2"
      }
    }
  }
}
*/
